import { GRID_ROW_HEIGHT, GRID_ROW_HEIGHT_EMPHASIZED } from '../../config'

export function getGridRowHeights(emphasizeHeader?: boolean) {
  const gridHeight = emphasizeHeader ? GRID_ROW_HEIGHT_EMPHASIZED : GRID_ROW_HEIGHT
  return { gridHeight }
}
